import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { InteractiveTutorial } from './InteractiveTutorial';
import { getTutorialById } from '../lib/tutorialData';

export const HelpButton = ({ tutorialId, className = '' }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isTutorialOpen, setIsTutorialOpen] = useState(false);
  const tutorial = getTutorialById(tutorialId);
  
  // Auto-start tutorial if URL has ?tutorial=<tutorialId>
  useEffect(() => {
    const tutorialParam = searchParams.get('tutorial');
    if (tutorialParam === tutorialId && tutorial) {
      // Small delay to allow page to render
      const timer = setTimeout(() => {
        setIsTutorialOpen(true);
        // Remove the query param after starting
        searchParams.delete('tutorial');
        setSearchParams(searchParams, { replace: true });
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [searchParams, tutorialId, tutorial, setSearchParams]);
  
  if (!tutorial) return null;
  
  const handleStartTutorial = () => {
    setIsTutorialOpen(true);
  };
  
  const handleCloseTutorial = () => {
    setIsTutorialOpen(false);
  };
  
  const handleLearnMore = (id) => {
    navigate(`/help/${id}`);
  };
  
  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleStartTutorial}
              className={`p-2 h-9 w-9 rounded-full hover:bg-[#1E3A5F]/10 text-[#1E3A5F] ${className}`}
              data-testid={`help-btn-${tutorialId}`}
            >
              <HelpCircle className="w-5 h-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="bg-[#000501] text-white border-0">
            <p>How to Get Started with {tutorial.title}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      <InteractiveTutorial
        tutorial={tutorial}
        isOpen={isTutorialOpen}
        onClose={handleCloseTutorial}
        onLearnMore={handleLearnMore}
      />
    </>
  );
};

export default HelpButton;
